import React, { useEffect } from 'react';

const PDFTemplates = () => {
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn('Placeholder: PDFTemplates is not implemented yet.');
  }, []);
  return (
    <>
  { /*PDFTemplates */} 
 </>
  );
};

export default PDFTemplates;
